// extracted by mini-css-extract-plugin
var _1 = "NoItems__NoItems___qvqUS";
var _2 = "NoItems__title___Evfe_";
var _3 = "NoItems__wiggle___RKLBX";
var _4 = "NoItems__wrap___THVPj";
export { _1 as "NoItems", _2 as "title", _3 as "wiggle", _4 as "wrap" }
